import styles from "./ProgressBar.module.css"
import React from 'react';
/**
* Props for the ProgressBar component.
*/ 
interface ProgressBarProps {
    stepNumber?: number; // Number of steps
    currentStep?: number; // Current step
    size?: ProgressBarSize // Size
}
type ProgressBarSize = 'small' | 'large'; // Progress barr size options
/**
* A progress bar component for displaying step progress.
* Handles the step logic
*
* @param props ProgressBarProps
* @param {number} props.stepNumber - Number of steps
* @param {number} props.currentStep - Current step
* @param {'small' | 'large'} props.size - Size
* @returns TSX.Element
*/
const ProgressBar: React.FC<ProgressBarProps> = ({ stepNumber = 5 , currentStep = 1, size="large"}) => {
    // Styles
    const sizeStyles: Record<ProgressBarSize, React.CSSProperties & Record<string, string>> = {
        large: {
            '--ball-size': '45px',
            '--line-height': '4px',
            '--font-size': '21px',
            '--label-line-height': '33px',
        },
        small: {
            '--ball-size': '30px',
            '--line-height': '2px',
            '--font-size': '14px',
            '--label-line-height': '22px',
        }
    };
    // Create array from number of steps
    const stepsArray = Array.from(Array(stepNumber).keys());
    // Generate the bar
    const bar = stepsArray.map((step, index)=>{
        if (index == 0 ) {
            return <div key={index} className={`${styles.ProgressBall} ${styles.PartDone}`} style={sizeStyles[size]}><p>{step+1}</p></div> ;
        } else {
            return <><div key={index} className={index < currentStep ? `${styles.ProgressBarPart} ${styles.PartDone}` : `${styles.ProgressBarPart}`}  style={sizeStyles[size]}><div className={styles.ProgressLine}></div><div key={index} className={styles.ProgressBall}><p>{step+1}</p></div></div></>;
        }
    })

    return(
        <>
            <div className={styles.BarContainer} >
                <div className={styles.ProgressBar}>
                    {bar}
                </div>
            </div>
        </>
    )
};

export default ProgressBar;